import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'I RISULTATI DELLA TUA RICERCA',
        description:
            "Questo è il risultato della ricerca. Per ogni esercizio vedi l'anno, il livello e di che tipo è. Vedi anche l'incipit dell'esercizio e gli argomenti su cui verte.",
        isActive: true,
        name: 'InvalsiExercisesSearchPanel',
        tutorialName: 'crea-verifica_risultati-INVALSI'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 35,
        yOffset: -710
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 20,
        yOffset: -1220
    }
};
